import styled from 'styled-components';

import { fromLarge } from 'styleUtils/mediaQueries';
import { gridRow } from 'styleUtils/grid';

export const PageSectionIntroLimiter = styled.div`
    padding: 1.5rem 0;
    ${gridRow({ start: 1 })}
    text-align: justify;
    *:last-child {
        margin-bottom: 0;
    }

    ${fromLarge`
        padding: 0;
        padding-right: 30%;
    `};
`;
